<script>
import { mapActions } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

export default {
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            groups: [],

            form: {
                id: '',
                bank_account_group_id: '',
                name: '',
                number: '',
                type_account: '',
                bank_id: '',
                number_bis: '',
                file: '',
                is_primary: false,
                is_active: true,
            },

            file: '',
            fileName: ''
        }
    },

    methods: {
        resetForm() {
            this.errors = {};

            this.form = {
                id: '',
                bank_account_group_id: '',
                name: '',
                number: '',
                type_account: '',
                bank_id: '',
                number_bis: '',
                file: '',
                is_primary: false,
                is_active: true,
            };

            this.file = '';
            this.fileName = '';

            if (this.$refs.file) {
                this.$refs.file.value = '';
            }
        },

        closedModal() {
            this.resetForm();
            this.$modal.hide('addContBanck');
        },

        async getGroups() {
            try {
                let { data } = await request.list('/bank_account_groups', 1, { name: '' });

                if (data) {
                    let groups = data.data ? data.data : data;

                    this.groups = groups.filter(group => !group.is_system);
                }
            } catch (error) {
                console.log(error);
                this.groups = [];
            }
        },

        catch_file(event) {
            if (!event.target.files || !event.target.files[0]) {
                return;
            }

            const validation = [
                "application/pdf",
                "image/gif",
                "image/jpeg",
                "image/jpg",
                "image/png",
            ];

            if (validation.includes(event.target.files[0].type)) {
                this.form.file = event.target.files[0];
                this.fileName = event.target.files[0].name;
            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos PDF e imágenes',
                });
            }
        },

        async saveBuildings() {
            let form = { ...this.form };

            if (!form.bank_account_group_id) {
                form.bank_account_group_id = '';
                form.is_primary = false;
            }

            let _endpoint = '/bank_accounts';

            if (form.id != "") {
                form._method = 'PUT';
                _endpoint = `/bank_accounts/${form.id}`;
            }

            try {
                let { data } = await request.postMedia(_endpoint, form);

                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-bank_accounts');
                }
            } catch (error) {
                this.errors = {};

                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },

        setFormFromAccount(account) {
            this.resetForm();

            if (!account || !account.id) {
                if (account && account.bank_account_group_id) {
                    this.form.bank_account_group_id = account.bank_account_group_id;
                }

                this.$modal.show('addContBanck');
                return;
            }

            this.form.id = account.id;

            this.form.bank_account_group_id = account.bank_account_group_id
                ? account.bank_account_group_id
                : account.group
                    ? account.group.id
                    : '';

            this.form.name = account.name ? account.name : '';
            this.form.number = account.number ? account.number : '';
            this.form.type_account = account.type_account ? account.type_account : '';
            this.form.bank_id = account.bank_id ? account.bank_id : '';
            this.form.number_bis = account.number_bis ? account.number_bis : '';
            this.form.file = '';
            this.form.is_primary = account.is_primary ? true : false;
            this.form.is_active = account.is_active === false || account.is_active === 0 ? false : true;

            this.file = account.file;

            this.$modal.show('addContBanck');
        },

        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },

    mounted() {
        this.catalogue.get_banks();
        this.catalogue.get_type_account();
        this.getGroups();
    },

    created() {
        Event.$on("event-show-addContBanck", async (account) => {
            await this.getGroups();
            this.setFormFromAccount(account);
        });

        Event.$on("event-load-bank_account_groups", async () => {
            await this.getGroups();
        });
    },

    beforeDestroy() {
        Event.$off("event-show-addContBanck");
        Event.$off("event-load-bank_account_groups");
    }
}
</script>

<template>
    <modal v-bind:click-to-close="false" name="addContBanck" :width="'80%'" :height="'auto'">
        <form @submit.prevent="saveBuildings" method="post" enctype="multipart/form-data">
            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="modal-header">
                <h5 class="modal-title">
                    {{ form.id ? 'Editar cuenta de banco' : 'Nueva cuenta de banco' }}
                </h5>
            </div>

            <div class="modal-body">
                <div class="row">

                    <div class="col-md-12">
                        <label>Grupo / Titular</label>

                        <select class="form-control" v-model="form.bank_account_group_id">
                            <option value="">Sin grupo</option>

                            <option
                                v-for="(group, index) in groups"
                                :value="group.id"
                                :key="index"
                            >
                                {{ group.name }}
                            </option>
                        </select>

                        <small class="text-muted">
                            Este campo es opcional. Para mover la cuenta, selecciona otro grupo o déjala sin grupo.
                        </small>

                        <div v-if="errors && errors.bank_account_group_id" class="text-danger">
                            {{ errors.bank_account_group_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <label>Nombre de la cuenta</label>

                        <input
                            type="text"
                            class="form-control"
                            v-model="form.name"
                            placeholder="Ejemplo: Cuenta renta, Cuenta proveedores, Cuenta principal BBVA"
                        >

                        <div v-if="errors && errors.name" class="text-danger">
                            {{ errors.name[0] }}
                        </div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <label>Número de cuenta</label>

                        <input type="number" class="form-control" v-model="form.number">

                        <div v-if="errors && errors.number" class="text-danger">
                            {{ errors.number[0] }}
                        </div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <label>Tipo de cuenta</label>

                        <select class="form-control" v-model="form.type_account">
                            <option value="">Selecciona una opción</option>

                            <option
                                v-for="(type_account, index) in catalogue.type_account"
                                :value="type_account.id"
                                :key="index"
                            >
                                {{ type_account.name }}
                            </option>
                        </select>

                        <div v-if="errors && errors.type_account" class="text-danger">
                            {{ errors.type_account[0] }}
                        </div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <label>No. Cta. Clave</label>

                        <input type="number" class="form-control" v-model="form.number_bis">

                        <div v-if="errors && errors.number_bis" class="text-danger">
                            {{ errors.number_bis[0] }}
                        </div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <label>Banco</label>

                        <select class="form-control" v-model="form.bank_id">
                            <option value="">Selecciona una opción</option>

                            <option
                                v-for="(bank, index) in catalogue.banks"
                                :value="bank.id"
                                :key="index"
                            >
                                {{ bank.name }}
                            </option>
                        </select>

                        <div v-if="errors && errors.bank_id" class="text-danger">
                            {{ errors.bank_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-6 mt-3" v-if="form.bank_account_group_id">
                        <div class="custom-control custom-switch">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="isPrimaryAccount"
                                v-model="form.is_primary"
                            >

                            <label class="custom-control-label" for="isPrimaryAccount">
                                Cuenta principal del grupo
                            </label>
                        </div>
                    </div>
<!-- 
                    <div class="col-md-6 mt-3">
                        <div class="custom-control custom-switch">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="isActiveAccount"
                                v-model="form.is_active"
                            >

                            <label class="custom-control-label" for="isActiveAccount">
                                Cuenta activa
                            </label>
                        </div>
                    </div> -->

                    <div class="col-md-12 mt-3">
                        <label>Carátula del estado de cta</label><br>

                        <div class="custom-file" :style="file != '' && file != null ? 'width: 87%' : 'width: 100%'">
                            <input
                                type="file"
                                class="custom-file-input"
                                :class="file != '' ? 'pr-5' : ''"
                                id="customFile"
                                ref="file"
                                @change="catch_file"
                            >

                            <label class="custom-file-label text-left" for="customFile">
                                {{ fileName || 'Seleccionar archivo' }}
                            </label>
                        </div>

                        <a
                            :href="`${globalUrlFiles}${file}`"
                            v-if="file != '' && file != null"
                            target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;"
                            class="btn btn-info"
                        >
                            <i class="fa-regular fa-file-pdf"></i>
                        </a>

                        <br>

                        <div v-if="errors && errors.file" class="text-danger">
                            {{ errors.file[0] }}
                        </div>
                    </div>

                    <div class="col-md-12">
                        <hr>

                        <button type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Guardar
                        </button>

                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>

                </div>
            </div>
        </form>
    </modal>
</template>